import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'isAdmin',
      'isManager',
      'isPosUser',
      'isChecker'
    ]),
    
    // Check if user has permission for general admin areas (Analytics, Events, News)
    // Includes POS users for read-only access to Events overview
    hasGeneralAdminPermission() {
      // Admin im eigenen Kontext: volle Rechte
      const isAdminInOwnContext = this.isAdmin && !this.$store.getters.adminSimulated && 
                                   this.$store.getters.currentForManagerId === this.$store.getters.ownManagerId;
      
      // Admin im fremden Kontext: nur Rechte der Invitation (canManage)
      // Oder Manager mit canManage Berechtigung
      const hasManagerPermission = this.isManager;
      
      // POS-User haben Leserecht (für Events-Übersicht)
      const hasPosPermission = this.isPosUser;
      
      const result = isAdminInOwnContext || hasManagerPermission || hasPosPermission;
      console.log('🔍 [PERMISSION MIXIN] hasGeneralAdminPermission:', result, { 
        isAdmin: this.isAdmin, 
        isManager: this.isManager,
        isPosUser: this.isPosUser,
        isAdminInOwnContext,
        hasPosPermission,
        currentForManagerId: this.$store.getters.currentForManagerId,
        ownManagerId: this.$store.getters.ownManagerId
      });
      return result;
    },
    
    // Check if user has permission for creating/editing Events and News (NO POS)
    hasAdminOrManagerPermission() {
      // Admin im eigenen Kontext: volle Rechte
      const isAdminInOwnContext = this.isAdmin && !this.$store.getters.adminSimulated && 
                                   this.$store.getters.currentForManagerId === this.$store.getters.ownManagerId;
      
      // Manager mit canManage Berechtigung
      const hasManagerPermission = this.isManager;
      
      // POS-User sind EXPLIZIT ausgeschlossen
      const result = isAdminInOwnContext || hasManagerPermission;
      console.log('🔍 [PERMISSION MIXIN] hasAdminOrManagerPermission:', result, { 
        isAdmin: this.isAdmin, 
        isManager: this.isManager,
        isPosUser: this.isPosUser,
        isAdminInOwnContext,
        currentForManagerId: this.$store.getters.currentForManagerId,
        ownManagerId: this.$store.getters.ownManagerId
      });
      return result;
    },
    
    // Check if user has permission for administration area (only real admins in own context)
    hasAdministrationPermission() {
      // Admin im eigenen Kontext: volle Rechte für Administration
      const isAdminInOwnContext = this.isAdmin && !this.$store.getters.adminSimulated && 
                                   this.$store.getters.currentForManagerId === this.$store.getters.ownManagerId;
      console.log('🔍 [PERMISSION MIXIN] hasAdministrationPermission:', isAdminInOwnContext, { 
        isAdmin: this.isAdmin, 
        adminSimulated: this.$store.getters.adminSimulated,
        currentForManagerId: this.$store.getters.currentForManagerId,
        ownManagerId: this.$store.getters.ownManagerId
      });
      return isAdminInOwnContext;
    },
    
    // Check if user has permission for POS area (Admin, Manager, or POS role)
    // Users with multiple roles (e.g. Checker + POS/Manager) can access POS
    hasPosPermission() {
      // POS access is allowed if user has POS, Manager, or Admin role (even if they also have Checker role)
      const result = this.isAdmin || this.isManager || this.isPosUser;
      console.log('🔍 [PERMISSION MIXIN] hasPosPermission:', result, { isAdmin: this.isAdmin, isManager: this.isManager, isPosUser: this.isPosUser, isChecker: this.isChecker });
      return result;
    },
    
    // Check if user has permission for ticket scanner area (only in app, not web)
    hasScannerPermission() {
      // Scanner haben im Web keinen Zugriff, nur in der App
      return false;
    }
  }
};
